import { render, staticRenderFns } from "./ModelsConfigurations.vue?vue&type=template&id=073bb6c0&scoped=true&"
import script from "./ModelsConfigurations.vue?vue&type=script&lang=js&"
export * from "./ModelsConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./ModelsConfigurations.vue?vue&type=style&index=0&id=073bb6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073bb6c0",
  null
  
)

export default component.exports